import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { icon } from '@fortawesome/fontawesome-svg-core/import.macro'
import moment from "moment-timezone";

import { ref, update, onChildAdded, onChildChanged } from "firebase/database";
import firebaseDb from "../../../../utils/firebase.util";
import { TIME_ZONE } from "../../../../config/variables";
import users_icon from "../../../../assets/images/icons/user.svg";
import package_icon from "../../../../assets/images/icons/package.svg";
import Brand from "../../../../assets/images/logo.png";

import { chat } from "../../../../redux/actions";
import { validateAndSortNumbers } from "../../../../utils/functions";
import useAssignmentsQueue from "../../../../hooks/useAssignmentsQueue";

function SuperAdminSideBar(props) {
  const assignments = useAssignmentsQueue();
  const [chatUnread, setChatUnread] = useState(0);

  var chatUnreadRef = useRef(0);
  const chatInitializeRef = useRef(false);
  var usersList = {};
  var keysArr = [];

  const user = props.user;

  let underscorePattern = /[_]/i;
  let filteredRole = user.role;
  if (underscorePattern.test(filteredRole)) {
    let splitStringToArr = filteredRole.split("_");
    filteredRole = "";
    for (let arrElm of splitStringToArr) {
      filteredRole = filteredRole + " " + arrElm;
    }
  }

  useEffect(() => {
    if (chatInitializeRef.current === false) {
      initiateChats();
    }
  }, [chatUnread]);

  const initiateChats = async () => {
    if (Object.keys(user).length > 0) {
      const chatListRef = ref(firebaseDb, `chats`);

      chatInitializeRef.current = true;

      onChildAdded(chatListRef, (data) => {
        var otherUser = null;

        let value = data.val();
        let recentCount = chatUnreadRef.current;
        for (let itemKey in value) {
          let usrItem = value[itemKey];

          // if(usrItem?.to_user_unique_id === user?.unique_id){
          //     if(usrItem?.is_seen == 0){
          //         recentCount = recentCount + 1
          //     }
          // }

          // if(usrItem.role != 'super_admin' && usrItem.role != 'sub_super_admin') {

          otherUser = usrItem;
          let keyName = `${usrItem.unique_id}`;

          if (!usersList.hasOwnProperty(keyName)) {
            usersList[keyName] = [];
          }
          if (
            usrItem["to_user_unique_id"] == user?.unique_id &&
            usrItem["is_seen"] === 0 &&
            !keysArr.includes(itemKey)
          ) {
            recentCount = recentCount + 1;
          }

          if (!keysArr.includes(itemKey)) {
            keysArr.push(itemKey);
            usersList[keyName].push(usrItem);
          }

          // }
        }

        /* Update status to Online, Offline */

        for (let itmKey in value) {
          let usrItm = value[itmKey];

          if (otherUser) {
            if (usrItm.role == user.role && usrItm.user_id == user.id) {
              const updates = {};
              updates[
                `chats/user_${validateAndSortNumbers(
                  otherUser.unique_id,
                  user.unique_id
                )}`
              ] = {
                ...value[itmKey],
                status: "online",
                timestamp: moment().tz(TIME_ZONE).format("XX"),
                timestampFormatted: moment()
                  .tz(TIME_ZONE)
                  .format("YYYY-MM-DD HH:mm:ss"),
              };

              update(ref(firebaseDb), updates);
            }
          }
        }

        chatUnreadRef.current = recentCount;
        setChatUnread(chatUnreadRef.current);
      });

      onChildChanged(chatListRef, (data) => {
        let value = data.val();
        let recentCount = chatUnreadRef.current;

        for (let key in value) {
          let usrItem = value[key];

          // if(usrItem.role != 'super_admin' && usrItem.role != 'sub_super_admin') {

          let keyName = `${usrItem.unique_id}`;
          if (!usersList.hasOwnProperty(keyName)) {
            usersList[keyName] = [];
          }

          if (
            usrItem["to_user_unique_id"] == user?.unique_id &&
            usrItem["is_seen"] === 0 &&
            !keysArr.includes(key)
          ) {
            recentCount = recentCount + 1;
          }

          if (!keysArr.includes(key)) {
            keysArr.push(key);
            usersList[keyName].push(usrItem);
            /* if( usrItem['is_seen'] === 0 ) {

                                    chatUnreadRef.current = chatUnreadRef.current + 1
        
                                }else {
    
                                    chatUnreadRef.current = Math.abs(chatUnreadRef.current - 1)
                                } */
          }

          // }
        }
        chatUnreadRef.current = recentCount;

        setChatUnread(chatUnreadRef.current);
      });
    }
  };

  return (
    <>
      <NavLink className="logged_user">
        {/* <img className='logged_user_img' src={user.picture_path} />
                <p>{user.full_name}</p>
                <span className='logged_user_typ'>{filteredRole}</span> */}

        <img width={100} src={Brand} />
      </NavLink>
      <Button className="toggle" onClick={props.toggleSideBar}>
        <span className="line-toggle"></span>
        <span className="line-toggle"></span>
        <span className="line-toggle"></span>
      </Button>
      <div className="sidebar_menu">
        <NavLink to="dashboard">
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="path_fill"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7 3C9.20914 3 11 4.79086 11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3ZM7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5ZM17 3C19.2091 3 21 4.79086 21 7C21 9.20914 19.2091 11 17 11C14.7909 11 13 9.20914 13 7C13 4.79086 14.7909 3 17 3ZM17 5C15.8954 5 15 5.89543 15 7C15 8.10457 15.8954 9 17 9C18.1046 9 19 8.10457 19 7C19 5.89543 18.1046 5 17 5ZM11 17C11 14.7909 9.20914 13 7 13C4.79086 13 3 14.7909 3 17C3 19.2091 4.79086 21 7 21C9.20914 21 11 19.2091 11 17ZM5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17ZM17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13ZM17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15Z"
                  fill=""
                />
              </svg>
            </span>
            <span className="">Dashboard</span>
          </div>
        </NavLink>
        <NavLink to="staffs" style={{ textTransform: "none" }}>
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              <img src={users_icon} width="22" height="25" />

              {/* <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_fill" d="M12.5656 0C12.8874 0 13.1349 0.2625 13.1349 0.575V4.6C13.1349 6.8875 15.0037 8.7625 17.2686 8.775C18.2092 8.775 18.9517 8.7875 19.521 8.7875L19.7319 8.78657C20.1123 8.78368 20.6246 8.775 21.0681 8.775C21.3775 8.775 21.625 9.025 21.625 9.3375V19.3875C21.625 22.4875 19.1374 25 16.0681 25H6.21658C2.99876 25 0.375 22.3625 0.375 19.1125V5.6375C0.375 2.5375 2.875 0 5.95668 0H12.5656ZM13.8899 16.125H7.15718C6.64975 16.125 6.22896 16.5375 6.22896 17.05C6.22896 17.5625 6.64975 17.9875 7.15718 17.9875H13.8899C14.3973 17.9875 14.8181 17.5625 14.8181 17.05C14.8181 16.5375 14.3973 16.125 13.8899 16.125ZM11.3403 9.875H7.15718C6.64975 9.875 6.22896 10.3 6.22896 10.8125C6.22896 11.325 6.64975 11.7375 7.15718 11.7375H11.3403C11.8478 11.7375 12.2686 11.325 12.2686 10.8125C12.2686 10.3 11.8478 9.875 11.3403 9.875ZM14.9384 1.1325C14.9384 0.59375 15.5856 0.32625 15.9557 0.715C17.2936 2.12 19.6314 4.57625 20.9384 5.94875C21.2998 6.3275 21.0349 6.95625 20.5139 6.9575C19.4965 6.96125 18.2973 6.9575 17.4347 6.94875C16.0658 6.94875 14.9384 5.81 14.9384 4.4275V1.1325Z" fill=""/>
                            </svg> */}
            </span>
            <span className="">In-house Staff</span>
          </div>
        </NavLink>
        <NavLink to="roles">
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              {/* <img src={package_icon} width="22" height="25" /> */}
              {/* <FontAwesomeIcon icon={({name: 'toolbox', style: 'solid'})} className="mx-2" style={{color: '#505154'}} /> */}
              <svg
                width="22"
                height="25"
                viewBox="0 0 22 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="path_fill"
                  d="M12.5656 0C12.8874 0 13.1349 0.2625 13.1349 0.575V4.6C13.1349 6.8875 15.0037 8.7625 17.2686 8.775C18.2092 8.775 18.9517 8.7875 19.521 8.7875L19.7319 8.78657C20.1123 8.78368 20.6246 8.775 21.0681 8.775C21.3775 8.775 21.625 9.025 21.625 9.3375V19.3875C21.625 22.4875 19.1374 25 16.0681 25H6.21658C2.99876 25 0.375 22.3625 0.375 19.1125V5.6375C0.375 2.5375 2.875 0 5.95668 0H12.5656ZM13.8899 16.125H7.15718C6.64975 16.125 6.22896 16.5375 6.22896 17.05C6.22896 17.5625 6.64975 17.9875 7.15718 17.9875H13.8899C14.3973 17.9875 14.8181 17.5625 14.8181 17.05C14.8181 16.5375 14.3973 16.125 13.8899 16.125ZM11.3403 9.875H7.15718C6.64975 9.875 6.22896 10.3 6.22896 10.8125C6.22896 11.325 6.64975 11.7375 7.15718 11.7375H11.3403C11.8478 11.7375 12.2686 11.325 12.2686 10.8125C12.2686 10.3 11.8478 9.875 11.3403 9.875ZM14.9384 1.1325C14.9384 0.59375 15.5856 0.32625 15.9557 0.715C17.2936 2.12 19.6314 4.57625 20.9384 5.94875C21.2998 6.3275 21.0349 6.95625 20.5139 6.9575C19.4965 6.96125 18.2973 6.9575 17.4347 6.94875C16.0658 6.94875 14.9384 5.81 14.9384 4.4275V1.1325Z"
                  fill=""
                />
              </svg>
            </span>
            <span className="">Roles</span>
          </div>
        </NavLink>
        <NavLink to="packages">
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              <img src={package_icon} width="22" height="25" />
              {/* <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_fill" d="M12.5656 0C12.8874 0 13.1349 0.2625 13.1349 0.575V4.6C13.1349 6.8875 15.0037 8.7625 17.2686 8.775C18.2092 8.775 18.9517 8.7875 19.521 8.7875L19.7319 8.78657C20.1123 8.78368 20.6246 8.775 21.0681 8.775C21.3775 8.775 21.625 9.025 21.625 9.3375V19.3875C21.625 22.4875 19.1374 25 16.0681 25H6.21658C2.99876 25 0.375 22.3625 0.375 19.1125V5.6375C0.375 2.5375 2.875 0 5.95668 0H12.5656ZM13.8899 16.125H7.15718C6.64975 16.125 6.22896 16.5375 6.22896 17.05C6.22896 17.5625 6.64975 17.9875 7.15718 17.9875H13.8899C14.3973 17.9875 14.8181 17.5625 14.8181 17.05C14.8181 16.5375 14.3973 16.125 13.8899 16.125ZM11.3403 9.875H7.15718C6.64975 9.875 6.22896 10.3 6.22896 10.8125C6.22896 11.325 6.64975 11.7375 7.15718 11.7375H11.3403C11.8478 11.7375 12.2686 11.325 12.2686 10.8125C12.2686 10.3 11.8478 9.875 11.3403 9.875ZM14.9384 1.1325C14.9384 0.59375 15.5856 0.32625 15.9557 0.715C17.2936 2.12 19.6314 4.57625 20.9384 5.94875C21.2998 6.3275 21.0349 6.95625 20.5139 6.9575C19.4965 6.96125 18.2973 6.9575 17.4347 6.94875C16.0658 6.94875 14.9384 5.81 14.9384 4.4275V1.1325Z" fill=""/>
                            </svg> */}
            </span>
            <span className="">Packages</span>
          </div>
        </NavLink>
        <NavLink to="school-type">
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              <svg
                width="22"
                height="25"
                viewBox="0 0 22 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="path_fill"
                  d="M11 0L0 6.25V8.75H1.83333V18.75C0.820833 18.75 0 19.5625 0 20.625V22.5C0 23.5625 0.820833 24.375 1.83333 24.375H20.1667C21.1792 24.375 22 23.5625 22 22.5V20.625C22 19.5625 21.1792 18.75 20.1667 18.75V8.75H22V6.25L11 0ZM11 2.8125L18.3333 7.1875V8.75H16.5V16.25L13.75 15V8.75H8.25V15L5.5 16.25V8.75H3.66667V7.1875L11 2.8125ZM3.66667 18.75H18.3333V22.5H3.66667V18.75Z"
                  fill=""
                />
              </svg>
              {/* <img src={package_icon} width="22" height="25" /> */}
            </span>
            <span className="">School-Type</span>
          </div>
        </NavLink>
        <NavLink to="organizations">
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="path_fill"
                  d="M9.20172 22.3405C8.68662 22.6946 8.06026 22.9024 7.39001 22.9024C6.71689 22.9024 6.09055 22.6946 5.57542 22.3403C4.12669 22.5133 2.99976 23.7482 2.99976 25.2439V26.4145C2.99976 26.7365 3.26027 26.9999 3.58507 26.9999H11.1948C11.5168 26.9999 11.7802 26.7365 11.7802 26.4145V25.2439C11.7802 23.7482 10.6506 22.5133 9.20162 22.3405H9.20172Z"
                  fill=""
                />
                <path
                  className="path_fill"
                  d="M9.43898 19.6827C9.43898 20.8142 8.52168 21.7315 7.39004 21.7315C6.25861 21.7315 5.34131 20.8142 5.34131 19.6827C5.34131 18.5511 6.25861 17.6338 7.39004 17.6338C8.52168 17.6338 9.43898 18.5511 9.43898 19.6827Z"
                  fill=""
                />
                <path
                  className="path_fill"
                  d="M24.4218 22.3405C23.9065 22.6946 23.2803 22.9024 22.6101 22.9024C21.937 22.9024 21.3106 22.6946 20.7955 22.3403C19.3466 22.5133 18.2198 23.7482 18.2198 25.2439V26.4145C18.2198 26.7365 18.4804 26.9999 18.8052 26.9999H26.4149C26.7369 26.9999 27.0003 26.7365 27.0003 26.4145V25.2439C27.0003 23.7482 25.8704 22.5133 24.4217 22.3405H24.4218Z"
                  fill=""
                />
                <path
                  className="path_fill"
                  d="M24.6586 19.6827C24.6586 20.8142 23.7413 21.7315 22.6099 21.7315C21.4782 21.7315 20.5609 20.8142 20.5609 19.6827C20.5609 18.5511 21.4782 17.6338 22.6099 17.6338C23.7413 17.6338 24.6586 18.5511 24.6586 19.6827Z"
                  fill=""
                />
                <path
                  className="path_fill"
                  d="M11.1952 12.3663H18.8049C19.1269 12.3663 19.3902 12.1029 19.3902 11.781V10.6103C19.3902 9.11466 18.2604 7.8797 16.8117 7.70696C16.2966 8.06077 15.6702 8.2686 15 8.2686C14.3269 8.2686 13.7005 8.06076 13.1854 7.70654C11.7365 7.87947 10.6097 9.11446 10.6097 10.6101V11.7808C10.6097 12.1027 10.8703 12.3663 11.1951 12.3663H11.1952Z"
                  fill=""
                />
                <path
                  className="path_fill"
                  d="M17.0488 5.04894C17.0488 6.18037 16.1315 7.09767 15 7.09767C13.8686 7.09767 12.9513 6.18037 12.9513 5.04894C12.9513 3.9173 13.8686 3 15 3C16.1315 3 17.0488 3.9173 17.0488 5.04894Z"
                  fill=""
                />
                <path
                  className="path_fill"
                  d="M15.5853 17.9767V15.2928C15.5853 14.9709 15.3219 14.7075 15 14.7075C14.678 14.7075 14.4147 14.9709 14.4147 15.2928V17.9767L12.2459 20.1455C12.0176 20.3738 12.0176 20.7455 12.2459 20.9738C12.3572 21.0879 12.5064 21.1465 12.6585 21.1465C12.8106 21.1465 12.957 21.0879 13.0711 20.9738L15 19.048L16.9287 20.9766C17.0399 21.0879 17.1892 21.1465 17.3415 21.1465C17.4936 21.1465 17.64 21.0879 17.7541 20.9738C17.9823 20.7455 17.9823 20.3738 17.7541 20.1455L15.5853 17.9767Z"
                  fill=""
                />
              </svg>
            </span>
            <span className="">Organizations</span>
          </div>
        </NavLink>
        {/* <NavLink to="dashboard">
                    <div className='d-flex align-items-center'>
                        <span className="menu_icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_fill" fillRule="evenodd" clipRule="evenodd" d="M7 3C9.20914 3 11 4.79086 11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3ZM7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5ZM17 3C19.2091 3 21 4.79086 21 7C21 9.20914 19.2091 11 17 11C14.7909 11 13 9.20914 13 7C13 4.79086 14.7909 3 17 3ZM17 5C15.8954 5 15 5.89543 15 7C15 8.10457 15.8954 9 17 9C18.1046 9 19 8.10457 19 7C19 5.89543 18.1046 5 17 5ZM11 17C11 14.7909 9.20914 13 7 13C4.79086 13 3 14.7909 3 17C3 19.2091 4.79086 21 7 21C9.20914 21 11 19.2091 11 17ZM5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17ZM17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13ZM17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15Z" fill=""/>
                            </svg>
                        </span>
                        <span className="">Dashboard</span>
                    </div>
                </NavLink> */}
        {/* <NavLink to="subscriptions">
                    <div className='d-flex align-items-center'>
                        <span className="menu_icon">
                            <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_fill" d="M20.32 0.75C23.175 0.75 25.4988 3.05252 25.4988 5.88143L25.5 9.22806C25.5 9.4733 25.4013 9.71111 25.2262 9.88451C25.05 10.0591 24.8125 10.157 24.5625 10.157C23.5362 10.157 22.7013 10.9844 22.7013 12.0012C22.7013 13.0181 23.5362 13.8455 24.5625 13.8455C25.08 13.8455 25.5 14.2616 25.5 14.7744V18.1198C25.5 20.9487 23.1775 23.25 20.3225 23.25H5.67875C2.82375 23.25 0.5 20.9487 0.5 18.1198V14.7744C0.5 14.2616 0.92 13.8455 1.4375 13.8455C2.465 13.8455 3.3 13.0181 3.3 12.0012C3.3 11.0104 2.49875 10.2648 1.4375 10.2648C1.18875 10.2648 0.95125 10.1669 0.775 9.99227C0.59875 9.81763 0.5 9.58106 0.5 9.33582L0.5025 5.88143C0.5025 3.05252 2.825 0.75 5.68 0.75H20.32ZM13.0025 7.19184C12.6475 7.19184 12.33 7.38754 12.1712 7.70214L11.26 9.53152L9.2275 9.82506C8.87625 9.8746 8.58875 10.1124 8.4775 10.4468C8.3675 10.7812 8.45625 11.1429 8.71125 11.3881L10.185 12.81L9.8375 14.8202C9.7775 15.167 9.91875 15.5114 10.2063 15.7182C10.3687 15.8334 10.5575 15.8928 10.7488 15.8928C10.895 15.8928 11.0425 15.8569 11.1775 15.7863L13 14.8376L14.8188 15.7839C15.1337 15.9511 15.5075 15.9251 15.7937 15.717C16.0825 15.5114 16.2238 15.167 16.1637 14.8202L15.815 12.81L17.2887 11.3881C17.545 11.1429 17.6338 10.7812 17.5225 10.4468C17.4125 10.1124 17.125 9.8746 16.7775 9.8263L14.7412 9.53152L13.83 7.70337C13.6737 7.38878 13.3562 7.19308 13.0025 7.19184Z" fill=""/>
                            </svg>
                        </span>
                        <span className="">Subscriptions</span>
                    </div>
                </NavLink> */}
        <NavLink to="interpretations">
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="path_fill"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.69049 0.0719065C6.48275 0.420086 4.56146 1.41955 2.93618 3.06515C1.91571 4.09829 1.18459 5.19424 0.692451 6.4283C0.131251 7.83532 0 8.56685 0 10.2858C0 12.0048 0.131251 12.7363 0.692451 14.1433C1.6561 16.5599 3.78888 18.7472 6.17148 19.7625C7.71986 20.4224 9.52805 20.7143 11.1335 20.5636L11.9405 20.4879L11.9782 18.7425L12.0159 16.9969L12.4204 16.1775C12.8384 15.3306 13.5842 14.5292 14.214 14.25C14.4548 14.1433 14.5541 14.0003 14.6487 13.6239C14.8357 12.8793 15.3767 11.9474 15.9052 11.4595C17.0812 10.374 18.9266 10.0058 20.3842 10.5659C20.5798 10.6412 20.5858 10.5986 20.5168 9.61677C20.3359 7.03839 19.336 4.84531 17.5062 3.01277C16.1277 1.63231 14.6011 0.755572 12.7297 0.270036C11.7753 0.0223202 9.66199 -0.0813698 8.69049 0.0719065ZM14.9968 7.05722C15.3494 7.33505 15.4452 7.73529 15.2482 8.10864C15.1627 8.27074 13.7942 9.69819 12.2071 11.2808C9.5578 13.9225 9.29143 14.158 8.95385 14.158C8.62175 14.158 8.41639 13.9881 6.83719 12.4065C5.29171 10.8589 5.08818 10.6142 5.08818 10.3042C5.08818 9.83663 5.49611 9.42531 5.95978 9.42531C6.25612 9.42531 6.48941 9.60859 7.63189 10.7397L8.95955 12.0542L11.5081 9.51459C12.9098 8.11778 14.1291 6.94933 14.2178 6.91792C14.5254 6.80886 14.7273 6.845 14.9968 7.05722ZM18.1912 12.101C17.6445 12.2802 17.2373 12.55 16.8772 12.9712C16.4359 13.4876 16.2585 14.0241 16.2585 14.8428C16.2585 15.3319 16.2246 15.4488 16.083 15.4488C15.5805 15.4488 14.9851 15.7485 14.4713 16.2598C13.7258 17.0019 13.6506 17.3728 13.6978 20.074C13.738 22.3769 13.8115 22.6729 14.5032 23.3155C15.2385 23.9985 15.2482 24 18.8362 24C22.0129 24 22.1257 23.9928 22.5571 23.7616C23.1198 23.4603 23.7057 22.7799 23.8671 22.2405C24.0673 21.5715 24.0328 17.7589 23.821 17.1364C23.5397 16.3095 22.4015 15.4488 21.5895 15.4488C21.4478 15.4488 21.414 15.3319 21.414 14.8428C21.414 14.5095 21.3579 14.0493 21.2893 13.8201C21.1274 13.2791 20.5375 12.5951 19.9925 12.3166C19.5152 12.0727 18.6083 11.9642 18.1912 12.101ZM19.4318 13.9919C19.6483 14.2086 19.6955 14.3624 19.6955 14.8524V15.4488H18.8362H17.977V14.8524C17.977 14.1346 18.2878 13.7278 18.8362 13.7278C19.0455 13.7278 19.2657 13.8254 19.4318 13.9919ZM19.4318 19.1549C19.9647 19.6884 19.5871 20.6118 18.8362 20.6118C18.627 20.6118 18.4068 20.5142 18.2407 20.3477C18.0744 20.1813 17.977 19.9608 17.977 19.7513C17.977 19.5418 18.0744 19.3213 18.2407 19.1549C18.4068 18.9883 18.627 18.8908 18.8362 18.8908C19.0455 18.8908 19.2657 18.9883 19.4318 19.1549Z"
                  fill=""
                />
              </svg>
            </span>
            <span className="" style={{ display: "flex" }}>
              Interpretations{" "}
              <div
                style={{
                  height: "25px",
                  width: "25px",
                  textAlign: "center",
                  borderRadius: "100%",
                  backgroundColor: "red",
                  color: "white",
                  marginLeft: "10px",
                }}
              >
                {assignments?.review_count}{" "}
              </div>{" "}
            </span>
          </div>
        </NavLink>
        <NavLink to="payments">
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              <svg
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  className="path_fill"
                  x="4"
                  y="5"
                  width="16"
                  height="6"
                  rx="1"
                  fill=""
                />
                <path
                  className="path_stroke"
                  d="M23.75 11.25C25.1313 11.25 26.25 12.3687 26.25 13.75V22.5C26.25 23.8813 25.1313 25 23.75 25H11.25C9.86875 25 8.75 23.8813 8.75 22.5V22.5"
                  stroke=""
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  className="path_stroke"
                  d="M18.75 21.25L21.25 18.75L18.75 16.25"
                  stroke=""
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  className="path_stroke"
                  d="M3.75 11.25H20V7.5C20 6.11875 18.8813 5 17.5 5H6.25C4.86875 5 3.75 6.11875 3.75 7.5V16.25C3.75 17.6313 4.86875 18.75 6.25 18.75H21.25"
                  stroke=""
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="">Payments</span>
          </div>
        </NavLink>
        <NavLink to="support">
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="path_stroke path_fill"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.87138 16.3125C7.88452 14.5891 9.28996 13.2013 11.0134 13.21C12.7369 13.2188 14.1283 14.6207 14.1239 16.3442C14.1196 18.0677 12.7212 19.4626 10.9977 19.4626C10.1651 19.4606 9.36743 19.1273 8.78088 18.5363C8.19433 17.9453 7.8671 17.1452 7.87138 16.3125Z"
                  fill=""
                  stroke=""
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  className="path_stroke"
                  d="M18.5017 13.1862C18.3751 13.1855 18.2606 13.2612 18.2117 13.378C18.1627 13.4948 18.1891 13.6295 18.2784 13.7193C18.3676 13.809 18.5022 13.8361 18.6193 13.7878C18.7363 13.7395 18.8126 13.6254 18.8126 13.4988C18.8133 13.416 18.7808 13.3363 18.7224 13.2776C18.664 13.2189 18.5845 13.186 18.5017 13.1862"
                  stroke=""
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  className="path_stroke"
                  d="M22.3921 13.1862C22.2655 13.1855 22.151 13.2612 22.102 13.378C22.0531 13.4948 22.0795 13.6295 22.1687 13.7193C22.258 13.809 22.3926 13.8361 22.5096 13.7878C22.6267 13.7395 22.703 13.6254 22.703 13.4988C22.7037 13.416 22.6712 13.3363 22.6128 13.2776C22.5543 13.2189 22.4749 13.186 22.3921 13.1862"
                  stroke=""
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  className="path_stroke path_fill"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.74512 26.4731V25.6915C4.75017 23.967 6.14691 22.5702 7.87142 22.5652H14.124C15.8485 22.5702 17.2453 23.967 17.2503 25.6915V26.4731C17.2491 26.9042 16.8999 27.2534 16.4688 27.2546H5.52669C5.09556 27.2534 4.74638 26.9042 4.74512 26.4731Z"
                  fill=""
                  stroke=""
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  className="path_stroke"
                  d="M11.344 8.49677C13.5403 5.35308 17.5288 4.00754 21.1807 5.17834C24.8325 6.34914 27.2951 9.76298 27.2541 13.5977C27.2131 17.4324 24.6781 20.7928 21.002 21.8852"
                  stroke=""
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="">Support</span>
          </div>
        </NavLink>
        {/* <NavLink to="chat" state={{ fromOtherPage : true }}>
                    <div className='d-flex align-items-center'>
                        <span className="menu_icon">
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path className="path_fill" fillRule="evenodd" clipRule="evenodd" d="M10.0282 0C4.50537 0 0.0282136 4.47715 0.0282136 10C0.0194714 12.3091 0.819006 14.5485 2.28821 16.33L0.288214 18.33C0.00446904 18.6176 -0.0783831 19.0476 0.0782136 19.42C0.248082 19.788 0.62327 20.017 1.02821 20H10.0282C15.5511 20 20.0282 15.5228 20.0282 10C20.0282 4.47715 15.5511 8.22968e-08 10.0282 0ZM10.0282 18H3.43821L4.36821 17.07C4.75594 16.68 4.75594 16.05 4.36821 15.66C1.6681 12.9629 1.2491 8.73406 3.36744 5.55952C5.48578 2.38498 9.55154 1.1488 13.0784 2.60691C16.6053 4.06503 18.6112 7.81138 17.8693 11.555C17.1275 15.2986 13.8446 17.997 10.0282 18Z" fill=""/>
                            </svg>
                        </span>
                        <span className="">Chat</span>
                    </div>
                    {chatUnread > 0 && 
                        <span className='badge'>{chatUnread}</span>
                    } 
                </NavLink> */}

        <NavLink to="logout">
          <div className="d-flex align-items-center">
            <span className="menu_icon">
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="path_fill"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.5303 7.96975C13.2374 7.67686 12.7626 7.67686 12.4697 7.96975C12.1768 8.26264 12.1768 8.73752 12.4697 9.03041L15.1893 11.7501L3 11.7501C2.58579 11.7501 2.25 12.0859 2.25 12.5001C2.25 12.9143 2.58579 13.2501 3 13.2501L15.1893 13.2501L12.4697 15.9698C12.1768 16.2626 12.1768 16.7375 12.4697 17.0304C12.7626 17.3233 13.2374 17.3233 13.5303 17.0304L17.5303 13.0304C17.8232 12.7375 17.8232 12.2626 17.5303 11.9698L13.5303 7.96975ZM16.2001 3.25C17.0525 3.25 17.6468 3.25058 18.1094 3.28838C18.5633 3.32547 18.824 3.3946 19.0216 3.49523C19.4449 3.71095 19.7891 4.05516 20.0048 4.47852C20.1055 4.67604 20.1746 4.9368 20.2117 5.39068C20.2495 5.85331 20.2501 6.44755 20.2501 7.3L20.2501 17.7C20.2501 18.5525 20.2495 19.1467 20.2117 19.6093C20.1746 20.0632 20.1055 20.324 20.0049 20.5215C19.7891 20.9448 19.4449 21.289 19.0216 21.5048C18.824 21.6054 18.5633 21.6745 18.1094 21.7116C17.6468 21.7494 17.0525 21.75 16.2001 21.75L11.8001 21.75C10.9476 21.75 10.3534 21.7494 9.89077 21.7116C9.43689 21.6745 9.17612 21.6054 8.97861 21.5048C8.55524 21.289 8.21104 20.9448 7.99532 20.5215C7.89468 20.324 7.82555 20.0632 7.78847 19.6093C7.75067 19.1467 7.75009 18.5525 7.75009 17.7L7.75009 16.5C7.75009 16.0858 7.4143 15.75 7.00009 15.75C6.58587 15.75 6.25009 16.0858 6.25009 16.5L6.25009 17.7L6.25009 17.7321L6.25009 17.7321C6.25008 18.545 6.25007 19.2006 6.29345 19.7315C6.33811 20.2781 6.43247 20.7582 6.65881 21.2025C7.01834 21.9081 7.59201 22.4817 8.29762 22.8413C8.74184 23.0676 9.22198 23.162 9.76862 23.2066C10.2995 23.25 10.9551 23.25 11.768 23.25L11.8001 23.25L16.2001 23.25L16.2322 23.25C17.045 23.25 17.7006 23.25 18.2316 23.2066C18.7782 23.162 19.2583 23.0676 19.7025 22.8413C20.4082 22.4817 20.9818 21.9081 21.3414 21.2025C21.5677 20.7582 21.6621 20.2781 21.7067 19.7315C21.7501 19.2006 21.7501 18.5449 21.7501 17.7321L21.7501 17.7L21.7501 7.3L21.7501 7.26788C21.7501 6.45505 21.7501 5.79944 21.7067 5.26853C21.6621 4.72189 21.5677 4.24175 21.3414 3.79754C20.9818 3.09193 20.4082 2.51825 19.7025 2.15872C19.2583 1.93239 18.7782 1.83803 18.2316 1.79336C17.7006 1.74999 17.045 1.74999 16.2322 1.75L16.2001 1.75L11.8001 1.75L11.768 1.75C10.9551 1.74999 10.2995 1.74999 9.76862 1.79336C9.22198 1.83803 8.74184 1.93239 8.29762 2.15873C7.59201 2.51825 7.01834 3.09193 6.65881 3.79754C6.43247 4.24175 6.33811 4.7219 6.29345 5.26853C6.25007 5.79944 6.25008 6.45506 6.25009 7.2679L6.25009 7.3L6.25009 8.5C6.25009 8.91421 6.58587 9.25 7.00008 9.25C7.4143 9.25 7.75009 8.91421 7.75009 8.5L7.75009 7.3C7.75009 6.44755 7.75067 5.85331 7.78847 5.39068C7.82555 4.93681 7.89468 4.67604 7.99532 4.47852C8.21104 4.05516 8.55524 3.71095 8.97861 3.49524C9.17612 3.3946 9.43689 3.32547 9.89076 3.28838C10.3534 3.25058 10.9476 3.25 11.8001 3.25L16.2001 3.25Z"
                  fill=""
                />
              </svg>
            </span>
            <span className="">Logout</span>
          </div>
        </NavLink>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.authenticate,
    chat: state.chat,
  };
};

export default connect(mapStateToProps, null)(SuperAdminSideBar);
